import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';

import { DropdownPillMenu } from 'components/Dropdown';
import { PFE_ICONS } from 'constants/icons';
import { schedulePropTypes, reduxFormPropTypes } from 'constants/propTypes';
import { getClasspassSpotsAllocationRange } from 'helpers/classpass-spots-allocation';

import './NetworkReservationsDropdown.scss';

export default class NetworkReservationsDropdown extends Component {
  static propTypes = {
    ...schedulePropTypes,
    ...reduxFormPropTypes.field,
    warn: PropTypes.bool,
    danger: PropTypes.bool,
  };

  componentDidUpdate(prevProps) {
    const {
      spots,
      input: { onChange },
    } = this.props;

    const { classpassTotal } = spots || {};

    if (prevProps.spots?.classpassTotal !== classpassTotal) {
      onChange(classpassTotal);
    }
  }

  renderNetworkMenuItem = text => {
    const { opportunity, spots } = this.props;
    const { recommendation } = opportunity || {};
    const { classpassTotal, smartspotRecommendedSpots } = spots || {};
    const recommendedSpots = (recommendation && classpassTotal + recommendation) || smartspotRecommendedSpots || null;

    if (text === recommendedSpots) {
      return (
        <div className="network-reservations-dropdown__recommendation">
          {text}
          <Isvg src={PFE_ICONS.opportunitiesFill} className="network-reservations-dropdown__icon" />
        </div>
      );
    }

    return text;
  };

  render() {
    const {
      input: { value, onChange },
      warn,
      danger,
    } = this.props;

    return (
      <DropdownPillMenu
        className="network-reservations-dropdown"
        items={getClasspassSpotsAllocationRange(this.props)}
        isSelected={x => x === value}
        renderMenuItem={this.renderNetworkMenuItem}
        onSelect={onChange}
        attachment="right"
        warn={warn}
        danger={danger}
        renderAsActive={false}
      />
    );
  }
}
